<template>
  <vetster-search-facet-group
    :label="$t('search.search-by-name')"
    group="NAME"
    :expanded="expanded"
  >
    <vetster-input-legacy
      v-model.trim="input"
      :placeholder="$t('search.start-typing-vets-name')"
    />
  </vetster-search-facet-group>
</template>

<script>
import debounce from 'lodash/debounce';

import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';

export default {
  name: 'VetsterSearchNameInput',

  components: { VetsterSearchFacetGroup },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    expanded: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    input: {
      get() {
        return this.$store.state.search.inputs.full_name;
      },

      set: debounce(function setInputsFullName(value) {
        this.$store.commit('search/setInputs', { full_name: value });
      }, 1000, {
        maxWait: 7500,
      }),
    },
  },
};
</script>
